import Vue from 'vue'
import Vuex from 'vuex'
import examInfo from './modules/data'
import loading from './modules/loading'
import getters from './getters'
// import tagsView from './modules/tagsView'

Vue.use(Vuex)

const store = new Vuex.Store({
	modules: {
		examInfo,
		loading
	},
	getters
})

export default store



// WEBPACK FOOTER //
// ./src/store/index.js